'use client'

import { useMemo } from 'react'
import { createClient } from '@/lib/supabase-client'

/**
 * Hook para obtener una instancia memoizada del cliente de Supabase.
 * Evita crear múltiples instancias innecesarias del cliente.
 * 
 * @returns Cliente de Supabase
 * 
 * @example
 * const supabase = useSupabase()
 * const { data } = await supabase.from('transactions').select('*')
 */
export function useSupabase() {
  return useMemo(() => createClient(), [])
}
